import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateBankProductForm } from "web_myplann/Portfolio/Pages/BankProductCreate/CreateBankProductForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddBankProductPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddBankProduct.title)}>
			<CreateBankProductForm />
		</PortfolioAddLayout>
	);
};
